import React from "react";
import Card from "react-bootstrap/Card";
import { Trans, useTranslation } from "react-i18next";


function PartnerCard() {
  const { t } = useTranslation();

  return (
    <Card className="policy-card partners-intro-card">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p className="about-text">
            <Trans
              i18nKey="aboutPartners.intro.p1"
              components={{
                r: <span className="small-r-symbol">®</span>,
              }}
            />
          </p>

          <p className="about-text">
            <span className="purple">{t("aboutPartners.intro.differentHeading")}</span>
          </p>

          <p className="about-text">
            {t("aboutPartners.intro.p2")}
          </p>              
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default PartnerCard;
